import { ProfileUserInfoResp } from 'types/api/response/profile-user-info-resp'

import { api } from './api'

export const getProfileUserInfo = (userId: number) =>
  api.get<ProfileUserInfoResp>(`users/${userId}/profile`)
